function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "70.8333333%",
  y1: "0%",
  x2: "29.1666667%",
  y2: "100%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E95D26",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C02227",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Izv\\u0113lies-savu-instruktoru-(Karti\\u0146as)",
  transform: "translate(-318.000000, -568.000000)",
  fill: "url(#linearGradient-1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Page-content",
  transform: "translate(294.000000, 136.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Details",
  transform: "translate(24.000000, 322.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Address",
  transform: "translate(0.000000, 104.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(0.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12,1.34110451e-07 C17.5228475,1.34110451e-07 22,4.4771526 22,10.0000001 C22,13.3716047 20.1975984,16.6760076 17.2259527,19.8127448 C16.2070021,20.8883037 15.118253,21.8681779 14.0291768,22.7354053 L13.6565722,23.0275578 L13.6565722,23.0275578 L13.4775129,23.1646463 L12.9722093,23.539195 L12.5547002,23.8320504 C12.2561229,24.0311019 11.8771884,24.0532188 11.560754,23.8984009 L11.4452998,23.8320504 L11.0277907,23.539195 L10.5224871,23.1646463 L10.1594592,22.8844562 C10.097345,22.8357606 10.0344529,22.7860734 9.97082322,22.7354053 C8.88174698,21.8681779 7.7929979,20.8883037 6.77404732,19.8127448 C3.80240157,16.6760076 2,13.3716047 2,10.0000001 C2,4.4771526 6.47715251,1.34110451e-07 12,1.34110451e-07 Z M12,2.00000013 C7.58172201,2.00000013 4,5.5817221 4,10.0000001 C4,12.7533955 5.57259843,15.6364927 8.22595268,18.4372555 C9.1757521,19.4398215 10.196378,20.3583849 11.2166768,21.170845 L11.5641242,21.4432903 L11.5641242,21.4432903 L12,21.772 L12.5209935,21.3773368 L12.7833232,21.170845 C13.803622,20.3583849 14.8242479,19.4398215 15.7740473,18.4372555 C18.4274016,15.6364927 20,12.7533955 20,10.0000001 C20,5.5817221 16.418278,2.00000013 12,2.00000013 Z M12,6 C14.209139,6 16,7.790861 16,10 C16,12.209139 14.209139,14 12,14 C9.790861,14 8,12.209139 8,10 C8,7.790861 9.790861,6 12,6 Z M12,8 C10.8954305,8 10,8.8954305 10,10 C10,11.1045695 10.8954305,12 12,12 C13.1045695,12 14,11.1045695 14,10 C14,8.8954305 13.1045695,8 12,8 Z",
  id: "icon"
})))))));

function SvgIcInstructorsLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D49AD1D3-83E6-4F48-873E-944AFBA55510") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInstructorsLocation);
export default __webpack_public_path__ + "static/media/ic-instructors-location.4d859d6a.svg";
export { ForwardRef as ReactComponent };